module.exports = "https://coursera_assets.s3.amazonaws.com/images/81644c849a0086f12a3c514402734ed9.svg";